"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

const NoVideosFound = props => {
  const {
    title,
    description,
    children,
    className
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('no-videos-found', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "no-videos-found__image"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "no-videos-found__title"
  }, title), description && /*#__PURE__*/_react.default.createElement("span", {
    className: "no-videos-found__description"
  }, description), children);
};

NoVideosFound.propTypes = {
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string
};
NoVideosFound.defaultProps = {
  description: null,
  children: null,
  className: ''
};
var _default = NoVideosFound;
exports.default = _default;